export default {
    getQueryStringByPara:function (targetStr, name) {
        var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i')
        var r = targetStr.split('?')[1].match(reg)
        if (r != null) return decodeURIComponent(r[2])
        return null
    },
    setUrlParameter:function (paraName, paraVal, link) {
        var reg = new RegExp(paraName + '='),
            link = (link ? link : window.location.href),
            newLink = link.split('?')[0],
            searchArr = (link.split('?')[1] ? link.split('?')[1] : '').split('&'),
            flag = false
        if(!link.split('?')[1]) {
            return newLink += '?' + paraName + '=' + paraVal
        }
        $(searchArr).each(function(index, item){
            if (reg.test(item)) {
                searchArr[index] = paraName + '=' + paraVal
                flag = true
            }
        })
        if(!flag) {
            searchArr.push(paraName + '=' + paraVal)
        }
        return newLink += '?' + searchArr.join('&')
    }
}